/******************************************************************************
 * AUTOGENERATED FILE - DO NOT EDIT
 * Edit template file instead at `/etc/build.ts.tmpl`
 * To re-trigger generation, run `make init`
 ******************************************************************************/
export const BUILD_PROFILE: "local" | "staging" | "prod" = "prod";
export const BUILD_VER = "261252108";
export const BUILD_TAG = "production-261252108";
export const BUILD_SHA = "c497dec8";
export const COGNITO_USER_POOL_ID = "us-west-2_rjKCiwu0o";
export const COGNITO_APP_CLIENT_ID = "20qvnq1dihp2mo7prsoh8c5jgd";
export const FIREBASE_AUTH_CONFIG_API_KEY = "AIzaSyDWkaQgBWTLDFT8YFfANkLrSCnmbSNnMUw";
export const FIREBASE_AUTH_CONFIG_APP_ID = "1:488583025960:web:3c76d2091e8b7cf8246c1d";
export const FIREBASE_AUTH_CONFIG_AUTH_DOMAIN = "swing-admin-app.firebaseapp.com";
export const FIREBASE_AUTH_CONFIG_MESSAGING_SENDER_ID = "488583025960";
export const FIREBASE_AUTH_CONFIG_PROJECT_ID = "swing-admin-app";
export const FIREBASE_AUTH_CONFIG_STORAGE_BUCKET = "swing-admin-app.firebasestorage.app";
export const SENTRY_ORG="swing-education";
export const SWING_SCHOOLS_SENTRY_PROJECT="swing-schools";
export const SWING_SCHOOLS_SENTRY_AUTH_TOKEN = "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";
export const SWING_SCHOOLS_SENTRY_DSN="https://d3b37685142dd340015c22853b9ea02c@o160562.ingest.us.sentry.io/4505882789806080";
export const LEGACY_COOKIE_DOMAIN = "swingeducation.com";
export const LEGACY_AUTH_TOKEN_COOKIE_NAME = "auth-token-prod";
export const APP_AUTH_TOKEN_COOKIE_NAME = "admin-app-auth-token";
export const INTERCOM_APP_ID = "etn432tp";
